import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

export interface ConsoleOrderRequest {
    category: string;
    limit: string;
    page: number;
    user_id: string;
    from_date: string; // YYYY-MM-DD
    to_date: string; // YYYY-MM-DD
    serial_number: string;
    order_state: string; // "대기" | "완료";
    delivery_type: string; // "편도" | "왕복" | "경유";
    car_type: string; // "오토바이" | "다마스" | "라보" | "벤" | "지하철" | "트럭";
    departure_dong_name: string;
    payment_type: string; // "선불" | "착불" | "신용" | "송금" | "수금";
    destination_dong_name: string;
}
export type DataListProps = {
    addition_cost: string;
    basic_cost: string;
    car_type: string;
    customer_department: string;
    customer_name: string;
    delivery_type: string;
    departure_address: string;
    departure_customer: string;
    departure_department: string;
    departure_dong_name: string;
    departure_staff: string;
    destination_address: string;
    destination_customer: string;
    destination_dong_name: string;
    order_date: string;
    order_state: string;
    order_state_code: string;
    payment_type: string;
    serial_number: string;
    total_cost: string;
};

export interface ResponseData {
    current_page: number;
    end_page: number;
    last_page: number;
    limit: number;
    max_page: number;
    start_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsoleQuickOrder = (data: ConsoleOrderRequest | null): UseQueryResult<ResponseData, Error> => {
    return useQuery({
        queryKey: ["useGetConsoleQuickOrder", data],
        queryFn: async () => {
            if (!data) throw new Error("Invalid request data");
            let url = enum_api_uri.get_console_quick_order;
            const response = await axiosInstance.get(url, {
                params: {
                    category: data.category,
                    limit: data.limit,
                    page: data.page,
                    user_id: data.user_id,
                    from_date: data.from_date,
                    to_date: data.to_date,
                    serial_number: data.serial_number,
                    order_state: data.order_state,
                    delivery_type: data.delivery_type,
                    car_type: data.car_type,
                    departure_dong_name: data.departure_dong_name,
                    payment_type: data.payment_type,
                    destination_dong_name: data.destination_dong_name,
                },
            });
            return response.data.data;
        },
        enabled: !!data && !!data.user_id,
    });
};
